import axios from "axios";
import { setAuthState } from "../features/auth/authSlice";
import store from "./store";
import { getRefreshToken, KEYCLOAK_BASE_URL, KEYCLOAK_CLIENT_ID, logout } from "./utils";

const axiosApiInstance = axios.create();

const isSessionInvalid = (error) =>
  axios.isAxiosError(error) &&
  error.response?.status === 400 &&
  error.response.data?.error === "invalid_grant";

const withRefreshLock = (fn) =>
  navigator.locks?.request
    ? navigator.locks.request("keycloak-token-refresh", fn)
    : fn();

const requestNewTokens = async () => {
  try {
    const res = await withRefreshLock(async () => {
      const response = await axios.post(
        `${KEYCLOAK_BASE_URL}/realms/parkit/protocol/openid-connect/token`,
        new URLSearchParams({
          grant_type: "refresh_token",
          client_id: KEYCLOAK_CLIENT_ID,
          refresh_token: getRefreshToken(),
        })
      );
      localStorage.setItem("refresh_token", response.data.refresh_token);
      return response;
    });
    store.dispatch(
      setAuthState({
        ...res.data,
        is_authenticated: true,
      })
    );
    return res;
  } catch (error) {
    if (isSessionInvalid(error)) {
      logout();
    }
    throw error;
  }
};

let refreshing = null;

export const refreshAccessToken = () => {
  if (!refreshing) {
    refreshing = requestNewTokens().finally(() => {
      refreshing = null;
    });
  }
  return refreshing;
};

axiosApiInstance.interceptors.response.use((response) => {
  return response
}, async function (error) {
  const originalRequest = error.config;
  const status = error.response?.status;
  if (
    (status === 403 || status === 401) &&
    originalRequest &&
    !originalRequest._retry &&
    getRefreshToken()
  ) {
    originalRequest._retry = true;
    try {
      const res = await refreshAccessToken();
      return axiosApiInstance({
        ...originalRequest,
        headers: {
          ...originalRequest.headers,
          Authorization: `Bearer ${res.data.access_token}`
        }
      });
    } catch {
      return Promise.reject(error);
    }
  }
  return Promise.reject(error);
});


export default axiosApiInstance;
